/**
 * Foca o primeiro campo com erro após falha na geração de etiquetas.
 * errorData.cards[].fields[].key: nome | raridade | edicao | infos | numeracao | ano | idioma | …
 */

export function getFirstTagErrorTarget(errorData) {
  const cards = errorData?.cards;
  if (!Array.isArray(cards)) return null;

  for (const card of cards) {
    const fieldKey = card?.fields?.[0]?.key;
    if (card?.serial && fieldKey) {
      return { serial: String(card.serial), fieldKey: String(fieldKey) };
    }
  }
  return null;
}

export function tagErrorFieldSelector(serial, fieldKey) {
  return `[data-tag-error-field="${serial}::${fieldKey}"]`;
}

/**
 * @param {object} errorData
 * @param {{ scrollBehavior?: ScrollBehavior, focusDelayMs?: number }} [options]
 * @returns {boolean} true se encontrou e tentou focar o elemento
 */
export function focusFirstTagErrorField(errorData, options = {}) {
  const target = getFirstTagErrorTarget(errorData);
  if (!target || typeof document === "undefined") {
    return false;
  }

  const el = document.querySelector(tagErrorFieldSelector(target.serial, target.fieldKey));
  if (!el) {
    return false;
  }

  const focusable =
    typeof el.focus === "function" && el.matches?.("input, textarea, select, button")
      ? el
      : el.querySelector?.("input, textarea, select, button");

  const scrollTarget = focusable || el;
  scrollTarget.scrollIntoView({
    behavior: options.scrollBehavior ?? "smooth",
    block: "center",
    inline: "nearest",
  });

  const delay = options.focusDelayMs ?? 350;
  window.setTimeout(() => {
    focusable?.focus?.({ preventScroll: true });
  }, delay);

  return true;
}
